import { Box, Flex, Heading, Text } from '@radix-ui/themes';
import type { AudienceCategoryItem, CountryItem } from '@digiseg-labs/api-client';
import AudienceBuilderCategory from './AudienceBuilderCategory';
import GenericSelect from '../GenericSelect';
import { GlobeIcon } from '@radix-ui/react-icons';

type Props = {
  categories: AudienceCategoryItem[];
  selectedCodes: Set<string>;
  onToggle: (categoryId: string, code: string) => void;
  countries: CountryItem[];
  selectedCountry: CountryItem | undefined;
  onCountryChange: (country: CountryItem | undefined) => void;
  isLoadingAudiences: boolean;
};

const AudienceBuilderFilters = ({
  categories,
  selectedCodes,
  onToggle,
  countries,
  selectedCountry,
  onCountryChange,
  isLoadingAudiences,
}: Props) => (
  <Box className="builder-panel builder-panel--filters">
    <Flex direction="column" gap="2">
      <Heading size="4">Build Audience</Heading>
      <Text size="2" color="gray">
        Choose a country and select the core audience segments.
      </Text>
      <GenericSelect
        items={countries}
        selectedItem={selectedCountry}
        onItemChange={onCountryChange}
        placeholder="Select a country…"
        sectionLabel="Countries"
        emptyOption={{
          label: "No Country",
          icon: <GlobeIcon />, 
          enabled: true,
        }}
      />
      {isLoadingAudiences && (
        <Text size="1" color="gray">
          Loading available audiences...
        </Text>
      )}
    </Flex>

    <Box className="builder-filter-scroll">
      {categories.map((category) => (
        <AudienceBuilderCategory
          key={category.code}
          category={category}
          selectedCodes={selectedCodes}
          onToggle={onToggle}
        />
      ))}
    </Box>
  </Box>
);

export default AudienceBuilderFilters;
